import React from 'react';
import { Form, Input } from 'antd';

const { Item } = Form;

const EmailFormItem = ({ disabled }) => {
  return (
    <Item 
      name="email"
      label="Adresse mail"
      rules={[
        {
          required: true,
          message: "Merci d'entrer votre adresse mail."
        }
      ]}
    >
      <Input disabled={disabled}/>
    </Item>
  );
};

export default EmailFormItem;
